const ColorPicker = {
    name: 'ColorPicker',
    data() {
        return {
            color: '#ffffff',
            useStorage: true,
        }
    },
    emits: ['changed'],
    methods: {
        loadColor() {
            if (this.useStorage == false) {
                return
            }

            if (window.localStorage?.getItem('cm:color_picker_option') == null) {
                this.saveColor()
                return
            }

            this.color = window.localStorage?.getItem('cm:color_picker_option');
        },
        saveColor() {
            if (this.useStorage == false) {
                return
            }

            window.localStorage.setItem('cm:color_picker_option', this.color);
        },
        listener(e) {

            this.color = e.target.value;
            this.saveColor();

            this.$emit('changed', this.color)
        },
    },

    mounted() {

        if (!window.localStorage) {
            this.useStorage = false;
        }

        this.loadColor();

        this.$nextTick(() => {
            this.$el.value = this.color;
            this.$el?.addEventListener('change', this.listener)
        })
    },

    render() {

        return this.$scopedSlots.default({
            color: this.color
        });
    }
}

export default ColorPicker;
